import { BarChart3, Building2, ClipboardList, CreditCard, FileText, GitBranch, LayoutDashboard, Package, PlugZap, ReceiptText, ShieldCheck, Upload, Users, UsersRound, type LucideIcon } from 'lucide-react';
import type { Permission } from '@portal/contracts';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission?: Permission;
  end?: boolean;
}
export interface NavGroup {
  label: string;
  items: NavItem[];
}

/** Items the signed-in role cannot use are hidden. The API enforces the same rules independently. */
export const NAV: NavGroup[] = [
  {
    label: 'Work',
    items: [
      { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, end: true },
      { to: '/invoices', label: 'Invoices', icon: FileText, permission: 'invoice:read' },
      { to: '/customers', label: 'Customers', icon: Users, permission: 'customer:read' },
      { to: '/products', label: 'Products & services', icon: Package, permission: 'catalog:read' },
      { to: '/imports', label: 'Import centre', icon: Upload, permission: 'import:read' },
    ],
  },
  {
    label: 'Reports',
    items: [
      { to: '/reports', label: 'Sales & tax', icon: BarChart3, permission: 'report:view', end: true },
      { to: '/reports/outstanding', label: 'Outstanding balances', icon: ReceiptText, permission: 'report:view' },
      { to: '/reports/payments', label: 'Payments', icon: CreditCard, permission: 'report:view' },
      { to: '/reports/exports', label: 'Exports', icon: ClipboardList, permission: 'export:run' },
    ],
  },
  {
    label: 'Settings',
    items: [
      { to: '/settings/business', label: 'Business & taxpayers', icon: Building2, permission: 'business:read' },
      { to: '/settings/branches', label: 'Branches', icon: GitBranch, permission: 'business:read' },
      { to: '/settings/team', label: 'Team & roles', icon: UsersRound, permission: 'team:read' },
      { to: '/settings/integration', label: 'NRS integration', icon: PlugZap, permission: 'integration:read' },
      { to: '/settings/security', label: 'Security', icon: ShieldCheck },
    ],
  },
];

export const PAGE_TITLES: Array<[RegExp, string]> = [
  [/^\/dashboard$/, 'Dashboard'],
  [/^\/invoices\/new$/, 'New invoice'],
  [/^\/invoices\/[^/]+\/edit$/, 'Edit invoice'],
  [/^\/invoices\/[^/]+$/, 'Invoice'],
  [/^\/invoices$/, 'Invoices'],
  [/^\/customers\/[^/]+$/, 'Customer'],
  [/^\/customers$/, 'Customers'],
  [/^\/products$/, 'Products & services'],
  [/^\/imports\/[^/]+$/, 'Import'],
  [/^\/imports$/, 'Import centre'],
  [/^\/reports$/, 'Sales & tax'],
  [/^\/reports\/outstanding$/, 'Outstanding balances'],
  [/^\/reports\/payments$/, 'Payments'],
  [/^\/reports\/exports$/, 'Exports'],
  [/^\/settings\/business$/, 'Business & taxpayers'],
  [/^\/settings\/branches$/, 'Branches'],
  [/^\/settings\/team$/, 'Team & roles'],
  [/^\/settings\/integration$/, 'NRS integration'],
  [/^\/settings\/security$/, 'Security'],
  [/^\/settings\/audit$/, 'Activity log'],
];
